import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { selectors, actions } from '../sagas/reservation';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import KmDatePicker from '../shared/KmDatePicker'
import KegTypeSize from './KegTypeSize';
import { Crementer } from '../shared/NumberCrementer'
import { FormError } from '../shared/FormError'
import Select from 'react-select';
import '../stylesheets/Reservations.css';
import 'react-select/dist/react-select.css';
import 'react-datepicker/dist/react-datepicker.css';

class FormStepOne extends Component {
  constructor(props) {
    super(props)
    this.incrementKeg = this.props.incrementKeg.bind(this)
    this.decrementKeg = this.props.decrementKeg.bind(this)
    this.incrementHandTap = this.props.incrementHandTap.bind(this)
    this.decrementHandTap = this.props.decrementHandTap.bind(this)
    this.submitFormOne = this.props.submitFormOne.bind(this)
    this.setDate = this.props.setDate.bind(this)
    this.setReturnDate = this.props.setReturnDate.bind(this)
    this.props.publicInformation(this.props.company_id)
  }

  handleCustomSubmit = () => {
    this.props.resetErrors()
    this.submitFormOne(this.props.formOne, this.props.company_id)
  }

  pickUpDate = (date) => {
    this.props.setDate(date)
    this.props.resetKegTypeSelection(this.props.number_of_kegs)
  }

  availableLimit = () => {
    return this.props.publicInfo
      && this.props.publicInfo.attributes
      && this.props.publicInfo.attributes.availableDateLimit || 0
  }

  futureLimit = () => {
    return this.props.publicInfo
      && this.props.publicInfo.attributes
      && this.props.publicInfo.attributes.futureDateLimit || 0
  }

  returnLimit = () => {
    return this.props.publicInfo
      && this.props.publicInfo.attributes
      && this.props.publicInfo.attributes.returnDateLimit || 0
  }

  waitForReservations = () => {
    return this.props.publicInfo
      && this.props.publicInfo.attributes
      && this.props.publicInfo.attributes.waitForReservations || 0
  }

  locationOptions = () => {
    const locations = this.props.publicInfo
      && this.props.publicInfo.attributes
      && this.props.publicInfo.attributes.locations || []

    const locationOptions = []

    locations.map( location => {
      locationOptions.push(
        {
          value: location.id,
          label: location && location.locationName
        }
      )
    })
    return locationOptions
  }

  handleLocation = (event) => {
    this.props.handleLocationSelect(event)
  }

  render () {
  //See this issue for more explanation as to
  //Why this is necessary
  //https://github.com/erikras/redux-form/issues/1270
    const { handleSubmit } = this.props
    let pick_up_date_limit = this.props.publicInfo && this.props.publicInfo.attributes && ( this.availableLimit() + this.futureLimit() )

    return(
    <div>
      { this.props.errors && Object.keys(this.props.errors).length > 0 && <FormError errors={this.props.errors}/> }
      <form onSubmit={handleSubmit(this.handleCustomSubmit)}>
        <div className={'pickup-date-wrapper'}>
          <KmDatePicker
            label={'Pickup Date'}
            wrapperClass={'half-size'}
            date={ this.props.pick_up_date }
            change={ this.pickUpDate }
            maxDate={ moment().add(this.waitForReservations() + pick_up_date_limit, "days") }
            minDate={ moment().add(this.waitForReservations(), "days") }
          />
          <KmDatePicker
            label={'Return Date'}
            wrapperClass={'half-size'}
            date={ this.props.return_date }
            change={ this.setReturnDate }
            maxDate={ moment(this.props.pick_up_date).add((this.waitForReservations() + this.returnLimit()), 'days') }
            minDate={ moment(this.props.pick_up_date).add(this.waitForReservations(), 'days') }
          />
        </div>
        { this.locationOptions().length > 1 &&
          <div className={'location'}>
            <div className={'location-select'}>
              <label>Location</label>
            </div>
            <Select
              className='km-select'
              name="form-field-name"
              clearable={ false }
              style={
                {
                  'color': '#333',
                  'backgroundColor': '#F9F9F9',
                  'outline': 'none',
                  'borderColor':'none',
                  'width': 317,
                  'height': 40,
                  'marginBottom': 23
                }
              }
              value={ this.props.location }
              options={ this.locationOptions() }
              optionClassName='km-select'
              defaultInputValue="Select Location"
              onChange={ (event) => this.handleLocation(event) }
            />
          </div>
        }
        <div className={'kegs'}>
          <Crementer
            label='How many kegs would you like?'
            wrapperClass='keg-amount-wrapper'
            incrementClass='keg-amount-right'
            decrementClass='keg-amount-left'
            valueClass='keg-amount'
            decrement = { this.decrementKeg }
            increment= { this.incrementKeg }
            value = { this.props.number_of_kegs }
          />
        </div>
        { this.props.number_of_kegs && Array.from({length: this.props.number_of_kegs}, (v, i) => i).map( keg_number =>
        <KegTypeSize
          key={ keg_number }
          kegNumber={ keg_number }
          company_id={ this.props.company_id }
          checkedInDateLimit={ this.availableLimit() }
          waitForReservations={ this.waitForReservations() }
          kegSizes={ this.props.publicInfo && this.props.publicInfo.selectedKegSizes }
        />
       )}
        <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', marginTop: 23}}>
          <div style={{ color: '#aaa', fontWeight: 400 }}>
          { this.props.publicInfo && "Don't see what you are looking for?" }
          </div>
          <div style={{ color: '#aaa', fontWeight: 400 }}>
            { this.props.publicInfo && this.props.publicInfo.attributes && this.props.publicInfo.attributes.phone && `Give us a call at ${this.props.publicInfo.attributes.phone}` + (this.props.publicInfo && this.props.publicInfo.attributes && this.props.publicInfo.attributes.companyEmail ? ' or' : null) }
          </div>
          <div style={{ color: '#aaa', fontWeight: 400 }}>
            { this.props.publicInfo && this.props.publicInfo.attributes && this.props.publicInfo.attributes.companyEmail && `email us at ${this.props.publicInfo.attributes.companyEmail}` }
          </div>

          <div style={{ color: '#aaa', fontWeight: 400, marginTop: 20, maxWidth: 315}}>
            { this.props.publicInfo && this.props.publicInfo.attributes && this.props.publicInfo.attributes.companyHours }
          </div>
        </div>
       <div className={'hand-tap-crementer'}>
          <Crementer
            label='Need any Hand Taps?'
            wrapperClass='hand-tap-amount-wrapper'
            incrementClass='keg-amount-right'
            decrementClass='keg-amount-left'
            valueClass='keg-amount'
            decrement = { this.decrementHandTap }
            increment= { this.incrementHandTap }
            value = { this.props.hand_taps }
          />
        </div>
        <button onClick={ this.props.resetForms } className='reservation-cancel' type="button">
          Cancel
        </button>
        <button className='reservation-save' type="submit">
          Submit
        </button>
      </form>
    </div>
    )
  }
}

const mapStateToProps = (store) => ({
  reservation: selectors.reservation(store),
  number_of_kegs: selectors.number_of_kegs(store),
  hand_taps: selectors.hand_taps(store),
  form_one: selectors.form_one(store),
  pick_up_date: selectors.pick_up_date(store),
  errors: selectors.keg_size_errors(store),
  return_date: selectors.return_date(store),
  publicInfo: selectors.publicInfo(store),
  location: selectors.location(store),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);

export default (connect(
  mapStateToProps, mapDispatchToProps)(
  reduxForm(
  { form: 'reservation_form_one'}
)(FormStepOne)));



// WEBPACK FOOTER //
// ./src/Reservations/FormOne.jsx